import React, {useState, useEffect, useRef} from "react";
import {Modal} from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// @ts-ignore
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import GreedImage from "./GridImage";
import Auxiliary from "util/Auxiliary";


const MediaList = (props) => {

  const [previewVisible, setPreviewVisible] = useState(false);
  const [indexValue, setIndexValue] = useState(false);
  
  const handleToggle = (value) => {
    setIndexValue(value)
    setPreviewVisible((previousState) => ({
      previewVisible: !previousState.previewVisible,
    }));
  };

  useEffect(() => {}, [indexValue]);

  return (
    <Auxiliary>
      <GreedImage mediaList={props.mediaList} handleToggle={handleToggle}/>
      <Modal visible={previewVisible.previewVisible} footer={null} onCancel={handleToggle}>
        <Carousel mediaList={props.mediaList} indexValue={indexValue}/>
      </Modal>
    </Auxiliary>
  );
};


function Carousel(props) {
  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: 'slides',
    initialSlide:props.indexValue
  };
  const sliderRef = useRef();
  if(sliderRef.current){
    sliderRef.current.slickGoTo(props.indexValue);
  }
  
  return (
    <Auxiliary>
      <h4>Slide Show</h4>
      <Slider {...settings} ref={sliderRef}>
        {props.mediaList.map((media, index) =>
          <div key={index}>
            <TransformWrapper defaultPositionX={0}>
              <TransformComponent>
            <img alt="example" style={{width: '100%'}} src={media.image}/>
            </TransformComponent>
           </TransformWrapper>
          </div>
        )
        }
      </Slider>
    </Auxiliary>
  );
}

export default MediaList;
